/**
 * Converts a city name to "Title Case" with proper capitalization:
 * - First letter of each word is uppercase
 * - All other letters are lowercase
 *
 * Examples:
 *   "paRIS de la tOur" -> "Paris De La Tour"
 *   "saint-étienne"    -> "Saint-Étienne"
 *
 * @param value - The input string to format
 * @returns The city name in proper title case
 */
export const formatCityNameWithProperCasing = (value: string | undefined): string => {
  if (!value) return '';

  return value.toLocaleLowerCase().replace(/\p{L}+/gu, (word) => word.charAt(0).toLocaleUpperCase() + word.slice(1));
};

/**
 * Normalizes and capitalizes a city name so that each word starts with an uppercase letter.
 * Removes all non-letter characters except spaces and hyphens.
 */
export const formatCityNameLettersAndSpaceOnly = (city: string | undefined): string | undefined => {
  if (!city) return '';
  // Keep only letters (including accents), spaces, apostrophes and hyphens
  const filteredValue = city.replace(/[^\p{L}' -]/gu, '');
  return formatCityNameWithProperCasing(filteredValue);
};
